export const beforeItems = [
  'You observe several behaviors but struggle to connect them.',
  'You review books, notes, and course materials trying to remember what matters.',
  'You find it difficult to separate observable behavior from your interpretation.',
  'You aren’t always sure which contextual factors deserve further investigation.',
  'You sometimes form a hypothesis before identifying all the information you need.',
  'You finish reviewing a case with more questions than answers.',
  'Complex sensory modulation cases can feel like starting from zero every time.',
];

export const afterItems = [
  'You organize the functional concern before interpreting the observations.',
  'You document what happened, when it happened, and in what context.',
  'You explore possible relationships between observations and sensory modulation.',
  'You identify missing information before strengthening a working hypothesis.',
  'You consider alternative explanations instead of relying on a single interpretation.',
  'You connect your reasoning with functional participation and meaningful activities.',
  'You follow a repeatable educational framework whenever you need to organize a complex case.',
];
